<template>
  <section class="section">
    <div ref="content" class="content">
      <div ref="texts" class="texts">
        <h2>
          {{"SECTION_ARCHITECTURE_TITLE".t()}}
        </h2>
        <p>
          <trans t="SECTION_ARCHITECTURE_DESC"><br /></trans>
        </p>
      </div>

      <div ref="info" class="info">
        <div class="info-coloumn">
          <div class="info-2-3">
            <div class="line line--reverse">
              <div class="line-arrow" />
            </div>
            <span>{{"SECTION_ARCHITECTURE_INFO_2-3".t()}}</span>
            <div class="line line--long">
              <div class="line-arrow" />
            </div>
          </div>
          
          <div class="info-3">
            <span>{{"SECTION_ARCHITECTURE_INFO_3".t()}}</span>
          </div>
        </div>

        <div class="info-coloumn">
          <div class="info-1">
            {{"SECTION_ARCHITECTURE_INFO_1".t()}}
          </div>

          <div class="info-1-2">
            <div class="line line--reverse">
              <div class="line-arrow" />
            </div>
            <span>{{"SECTION_ARCHITECTURE_INFO_1-2".t()}}</span>
            <div class="line">
              <div class="line-arrow" />
            </div>
          </div>
          
          <div class="info-2">
            <trans t="SECTION_ARCHITECTURE_INFO_2"><br /></trans>
          </div>

          <div class="info-2-4">
            <div class="line line--reverse">
              <div class="line-arrow" />
            </div>
            <span>{{"SECTION_ARCHITECTURE_INFO_2-4".t()}}</span>
            <div class="line">
              <div class="line-arrow" />
            </div>
          </div>

          <div class="info-4">
            <span>{{"SECTION_ARCHITECTURE_INFO_4".t()}}</span>
          </div>
        </div>

        <div class="info-coloumn">
          <div class="info-2-5">
            <div class="line line--reverse">
              <div class="line-arrow" />
            </div>
            <span>{{"SECTION_ARCHITECTURE_INFO_2-5".t()}}</span>
            <div class="line line--long">
              <div class="line-arrow" />
            </div>
          </div>

          <div class="info-5">
            <span>{{"SECTION_ARCHITECTURE_INFO_5".t()}}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Logo from './Logo';

export default {
  mounted() {
    let interSected = false;

    const observer = new IntersectionObserver(
    entries => 
    {
      entries.forEach(entry => {
        if (!interSected && entry.isIntersecting)
        {
          interSected = true;

          this.$anime({
            targets: this.$refs.texts.querySelectorAll("h2, p"),
            translateY: ["100%", 0],
            translateZ: 0,
            opacity: [0, 1],
            duration: 750,
            easing: "easeOutExpo",
            delay: (el, i) => 300 * i,
          });

          this.$anime({
            targets: [
              this.$refs.info.querySelector(".info-1"),
              this.$refs.info.querySelector(".info-2"),
              this.$refs.info.querySelector(".info-3"),
              this.$refs.info.querySelector(".info-4"),
              this.$refs.info.querySelector(".info-5"),
            ],
            scale: [0.7, 1],
            translateZ: 0,
            opacity: [0, 1],
            duration: 750,
            easing: "easeOutExpo",
            delay: (el, i) => 300 + (i > 1 ? 600 : 300 * i)
          });

          this.$anime({
            targets: [
              this.$refs.info.querySelector(".info-1-2"),
              this.$refs.info.querySelector(".info-2-3"),
              this.$refs.info.querySelector(".info-2-4"),
              this.$refs.info.querySelector(".info-2-5"),
            ],
            opacity: [0, 1],
            duration: 1000,
            easing: "easeOutExpo",
            delay: (el, i) => 1200
          });
        }
      });
    },
    {
      threshold: 0
    });
    observer.observe(this.$refs.content);
  },
  components: {
    Logo,
  }
}
</script>

<style scoped>
.section {
}

.content {
  position: relative;
  padding: 13rem 0;
  margin: 0 auto;
  max-width: 1440px;
  width: 100%;
  text-align: center;
}

.texts {

  & h2 {
    font-weight: 700;
    font-size: 5rem;
    line-height: 120%;
    color: #000000;
  }

  & p {
    margin-top: 4rem;
    font-size: 2.6rem;
    line-height: 120%;
    color: #000000;
  }
}

.info {
  display: flex;
  align-items: flex-end;
  justify-content: center;

  margin-top: 4.86rem;
}

.line {
  position: relative;
  left: 50%;
  top: 0;
  width: 0.3rem;
  height: 3rem;
  background:  #B8AA9F;
  border-radius: 1.33rem;
  transform: translate(-50%);
}

.line--long {
  height: 14rem; 
}

.line--reverse {
  align-self: flex-end;
  transform: translate(-50%) scaleY(-1);
}

.line-arrow {
  position: absolute;
  bottom: 0;

  &::before {
    content: "";
    position: absolute;
    left: -0.26rem;
    bottom: 0;
    width: 0.3rem;
    height: 1rem;
    background: #B8AA9F;
    border-radius: 0.26rem;
    transform: rotate(-45deg);
  }

  &::after {
    content: "";
    position: absolute;
    left: 0.26rem;
    bottom: 0;
    width: 0.3rem;
    height: 1rem;
    background: #B8AA9F;
    border-radius: 0.26rem;
    transform: rotate(45deg);
  }
}

.info-coloumn {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.info-1 {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 32.5rem;
  height: 9.8rem;
  background: #F7F7FA;
  border: 0.2rem solid #7D6C60;
  box-shadow: 0.3rem 0.3rem 0 #7D6C60;
  border-radius: 1rem;

  text-align: center;
  font-weight: 700;
  font-size: 2.3rem;
  line-height: 140%;
}

.info-1-2, .info-2-4 {
  margin: 1.5rem 0;

  & span {
    font-weight: 600;
    font-size: 2.1rem;
    line-height: 132%;
    color: #7D6C60;
  }
}

.info-2 {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 32.5rem;
  height: 11.4rem;
  background: #FFF200;
  border: 0.2rem solid #7D6C60;
  box-shadow: 0.3rem 0.3rem 0 #B8AA9F;
  border-radius: 7rem;

  font-weight: 700;
  font-size: 2.6rem;
  color: #000000;
}

.info-2-3 {
  position: relative;
  margin: 1.5rem 0;

  & span {
    display: block;
    margin-bottom: 0.5rem;
    
    font-weight: 600;
    font-size: 2.1rem;
    line-height: 132%;
    color: #7D6C60;
  }

  & .line--reverse {
    position: absolute;
    height: 2.8rem;
    transform: translate(11rem, 0rem) scaleY(-1) rotate(-90deg);
  }
}

.info-2-5 {
  position: relative;
  margin: 1.5rem 0;

  & span {
    display: block;
    margin-bottom: 0.5rem;
    
    font-weight: 600;
    font-size: 2.1rem;
    line-height: 132%;
    color: #7D6C60;
  }

  & .line--reverse {
    position: absolute;
    height: 7rem;
    transform: translate(-9rem, -2.2rem) scaleY(-1) rotate(90deg);
  }
}

.info-3, .info-4, .info-5 {
  display: flex;
  justify-content: center;
  align-items: center;

  margin: 0 -0.8rem;
  width: 28.4rem;
  height: 8.3rem;
  background: #F7F7FA;
  border: 0.2rem solid #A59E9E;
  box-shadow: 0.3rem 0.3rem 0 #A59E9E;
  border-radius: 5rem;

  font-weight: 700;
  font-size: 2.3rem;
  line-height: 140%;
  text-align: center;
  color: #60554C;
}

@media (max-width: 425px) {
  .content {
    padding: 6rem 0;
  }

  .texts {

    & h2 {
      font-size: 2rem;
    }

    & p {
      margin-top: 1.5rem;
      font-size: 1.4rem;
      line-height: 2rem;
      padding: 0 5rem;
    }
  }

  .info {
    padding-bottom: 15rem;
  }

  .info-coloumn:first-child {
    align-items: flex-start;

    margin-bottom: -12rem;
    margin-right: -12rem;

    & .info-2-3 {

      & span {
        margin-bottom: 0.3rem;
        width: 5rem;
        font-size: 1.6rem;
        white-space: nowrap;
      }

      & .line--long {
        height: 2rem;
      }

      & .line--reverse {
        height: 15rem;
        transform: scaleY(-1) translateY(100%);
      }
    }
  }

  .info-coloumn:last-child {
    align-items: flex-end;

    margin-bottom: -12rem;
    margin-left: -12rem;

    & .info-2-5 {

      & span {
        margin-bottom: 0.3rem;
        width: 5rem;
        font-size: 1.6rem;
        white-space: nowrap;
      }

      & .line--long {
        height: 2rem;
      }

      & .line--reverse {
        height: 15rem;
        transform: scaleY(-1) translateY(100%);
      }
    }
  }

  .info-1 {
    width: 23rem;
    height: 5.5rem;
    border-radius: 1rem;
  }

  .info-2 {
    width: 32rem;
    height: 9rem;
    border: 0.2rem solid #7D6C60;
    box-shadow: 0.3rem 0.3rem 0 #B8AA9F;
    border-radius: 38rem;

    font-size: 2.2rem;
  }

  .info-1-2, .info-2-4 {
    margin: 1rem 0;

    & span {
      font-size: 1.6rem;
    }
  }

  .info-3, .info-4, .info-5 {
    border: 0.2rem solid #A59E9E;
    box-shadow: 0.2rem 0.2rem 0 #A59E9E;
    border-radius: 2.5rem;

    width: 15rem;
    height: 5rem;
    font-size: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SectionAchitecture.vue